export const quetions = [
  {
    id: 1,
    question: 'Have you written a Will before?',
    fieldName: 'doYouHaveWill'
  },
  {
    id: 2,
    question: 'Do you have a spouse or partner?',
    fieldName: 'doYouHaveSpouse'
  },
  {
    id: 3,
    question: 'Do you have a child under 18?',
    fieldName: 'doYouHaveUnderAgeChild'
  },
  {
    id: 4,
    question: 'Do you have insurance?',
    fieldName: 'doYouHaveInsurance'
  },
  {
    id: 5,
    question: 'Do you have a pension (RSA) Account?',
    fieldName: 'doYouHavePensionAccount'
  }
];

export const quetionsTwo = [
  {
    id: 1,
    question: 'Do you have employee benefits?',
    fieldName: 'doYouHaveEmployeeBenefit'
  },
  {
    id: 2,
    question: 'Do you have bank accounts?',
    fieldName: 'doYouHaveBankAccount'
  },
  {
    id: 3,
    question: 'Do you have bonds, stocks or shares?',
    fieldName: 'doYouHaveBondShare'
  },
  {
    id: 4,
    question: 'Do you have other assets?',
    fieldName: 'doYouHaveAsset'
  },
  {
    id: 5,
    question:
      'Do you have any special instructions pertaining to the distribution of your assets?',
    fieldName: 'doYouHaveSpecialInstruction'
  },
  {
    id: 6,
    question: 'Do you need to appoint a trustee?',
    fieldName: 'doYouNeedTrustee'
  }
];

export type OptionType = {
  id: number;
  question: string;
  fieldName: string;
};
